
import Vue from "vue";
import ModalContainer from "@/@shell/modal/components/ModalContainer.vue";
import SnackbarContainer from "@/@shell/snackbar/components/SnackbarContainer.vue";

export default Vue.extend({
  components: {
    ModalContainer,
    SnackbarContainer,
  },
  // eslint-disable-next-line
  errorCaptured(err: any, vm: any, info: any) {
    // TODO: what should this be exactly?
    console.log("snackbar:", err);
    this.$snackbar.show(err.toString(), 10000, [{ label: "close", value: "" }], { error: true });
    return false;
  },
});
